import Helper from './Helper';

class  Animate {

  constructor() {

    let s = [
      '.home .ns-image-text',
      '.ns-keyfigure__item',
      '.home .ns-three-col-container__col'
    ]

    const selectors = s.join(',');

    const elements = Array.prototype.slice.call(document.querySelectorAll(selectors));
    elements.forEach(e => {
      if (!Helper.jizzInViewport(e)) {
        e.classList.add('animate');
      } else {
        e.classList.add('animate');
        e.classList.add('animated');
      }
      Helper.loadImagesInDomElement(e);
    });

    document.addEventListener('notesopen', () => {
      this.animateInPopup(selectors);
    });

    this.handleScroll(elements);

    window.addEventListener("scroll", e => {
      this.handleScroll(elements);
    });
  }

  handleScroll(elements) {
    elements.forEach(e => {
      if (Helper.jizzInViewport(e)) {
        e.classList.add('animated');
      }
    });
  }

  animateInPopup(selectors) {
    const elements = Array.prototype.slice.call(document.querySelectorAll(selectors));
    elements.forEach(e => {
      e.classList.add('animate');
      e.classList.add('animated');
      Helper.loadImagesInDomElement(e);
    });
  }
}
export default Animate;
